import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useGlobalStore } from "../../../../store";

interface Props {
  to?: string;
}

export default function RedirectIfNotAuthenticated(props: Props) {
  const { state } = useGlobalStore();
  const navigate = useNavigate();
  const redirectTo = props.to ? props.to : "/login";

  useEffect(() => {
    if (!state.isUserLoggedIn) {
      navigate(redirectTo, { replace: true, state: { isRedirected: true } });
    }
  }, [state.isUserLoggedIn, redirectTo, navigate]);

  if (!state.isUserLoggedIn) {
    return null;
  }

  return <Outlet />;
}
